/* global window */
import React, { PureComponent } from 'react';
import { Map } from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { shouldChangeArtboard, updateArtboard } from 'PreviewActions';
import { getMetadata, getSelectedAdstate } from 'Selectors';
import { RevealContainer } from 'PreviewComponents/ResizableContainer/RevealContainer';
import {
  DEVICE_ORIENTATION,
  FIT_TO_SCREEN,
  CANVAS_SCALE,
  MAX_HEIGHT,
  DIMENSIONS,
  MAX_WIDTH,
  DEVICE,
  BOUNDS,
} from 'PreviewConstants/';
import {
  UI,
} from 'SharedConstants/';

class DeviceContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { adLoaded: false };
  }
  componentDidMount() {
    document.addEventListener('artboard-change', this.handleChange, false);
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.dimensions !== this.props.dimensions
    ||
      prevProps.fitToScreen !== this.props.fitToScreen
    ) {
      shouldChangeArtboard();
    }
  }
  handleChange = (evt) => {
    const { updateArtboard } = this.props;
    const { rootElement, artboards } = store.getState();
    const artboardName = rootElement.parentNode.getAttribute('data-artboard');
    const selectedArtboardKey = artboards.find(a => a.name === artboardName).key;
    updateArtboard(selectedArtboardKey);
  };
  render() {
    const {
      props: {
        artboardName,
        children,
        isDevice,
      },
    } = this;

    return (
      <RevealContainer
        artboardName={artboardName}
        width={'100%'}
        height={'500px'}
        isDevice={isDevice}
      >
        {children}
      </RevealContainer>
    );
  }
}

DeviceContainer.propTypes = {
  revealFormat: PropTypes.bool.isRequired,
  artboardName: PropTypes.string.isRequired,
  dimensions: PropTypes.instanceOf(Map).isRequired,
  maxWidth: PropTypes.number.isRequired,
  maxHeight: PropTypes.number.isRequired,
  children: PropTypes.node,
  updateDimensions: PropTypes.func.isRequired,
  updateArtboard: PropTypes.func.isRequired,
  canvasScale: PropTypes.number.isRequired,
  fitToScreen: PropTypes.bool.isRequired,
  reloadAd: PropTypes.func.isRequired,
  device: PropTypes.instanceOf(Map),
  isDevice: PropTypes.bool.isRequired,
  deviceOrientation: PropTypes.string.isRequired,
};

DeviceContainer.defaultProps = {
  children: null,
  device: null,
};

const mapStateToProps = (state) => {
  const adState = getSelectedAdstate(state);
  return {
    revealFormat: getMetadata(state).get('revealFormat') || getMetadata(state).get('formatName') === 'Scroller',
    artboardName: adState.name,
    dimensions: state.getIn([UI, DIMENSIONS]),
    maxWidth: state.getIn([UI, BOUNDS, MAX_WIDTH]),
    maxHeight: state.getIn([UI, BOUNDS, MAX_HEIGHT]),
    canvasScale: state.getIn([UI, CANVAS_SCALE]),
    fitToScreen: state.getIn([UI, FIT_TO_SCREEN]),
    device: state.getIn([UI, DEVICE]),
    deviceOrientation: state.getIn([UI, DEVICE_ORIENTATION]),
  };
};

const mapDispatchToProps = dispatch => ({
  updateArtboard: artboard =>
    dispatch(updateArtboard(artboard)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeviceContainer);



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Preview/components/DeviceContainer/DeviceContainer.jsx